// extracted by mini-css-extract-plugin
export default {"header":"Header_header__nDtmC","main-image":"Header_main-image__O1Lct","active":"Header_active__tK8Zb","button":"Header_button__VSfxq"};